import React from 'react';
import "../../styles/home/imp-link.css";
import { Link } from 'react-router-dom';

const ImportantLinksSlider = () => {
    return (
        <div className="important-links py-5">
            <div className="container main-box">
                <h1 className="my-heading">Important Websites</h1>
                <div className="slider">
                    <div className="slide-track boxes">
                        <Link to={"https://mhrd.gov.in/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\MHRD.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://icssr.org/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\Indian-council.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"http://socialjustice.nic.in/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\Minsitry.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://nad.gov.in/students"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\NAD.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://nad.digitallocker.gov.in/students"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\Digilocker.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://dst.gov.in/hi"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\Ministry-science.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"http://upgovernor.gov.in/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\icn-rajbhavan.jpg" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://www.ugc.ac.in/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\icn-ugc.jpg" alt="" />
                            </div>
                        </Link>
                        <Link to={"http://uphed.gov.in/hi"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\icn-uphe.jpg" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://www.vlab.co.in/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\icn-vl.jpg" alt="" />
                            </div>
                        </Link>
                        {/* Calling again */}
                        <Link to={"https://mhrd.gov.in/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\MHRD.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://icssr.org/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\Indian-council.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"http://socialjustice.nic.in/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\Minsitry.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://nad.gov.in/students"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\NAD.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://nad.digitallocker.gov.in/students"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\Digilocker.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://dst.gov.in/hi"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\Ministry-science.png" alt="" />
                            </div>
                        </Link>
                        <Link to={"http://upgovernor.gov.in/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\icn-rajbhavan.jpg" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://www.ugc.ac.in/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\icn-ugc.jpg" alt="" />
                            </div>
                        </Link>
                        <Link to={"http://uphed.gov.in/hi"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\icn-uphe.jpg" alt="" />
                            </div>
                        </Link>
                        <Link to={"https://www.vlab.co.in/"} target="_blank">
                            <div className="box slide">
                                <img src="..\assets\images\images\icn-vl.jpg" alt="" />
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ImportantLinksSlider;